define([
	"./_FrontBack",
	"./PluginFactory"
], function(_FrontBack, PluginFactory) {

	return PluginFactory.declare(_FrontBack, {
		bBack: true,
		materialIcon: "flip_to_back",
		pluginName: "back",
		title: "CanvasSendToBack"
	});
});
